import React from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { BugIcon, TypeIcon, Heading1Icon, ImageIcon, CheckCircle2Icon, InfoIcon } from 'lucide-react';
const FixGroup = ({
  icon: Icon,
  title,
  items
}: {
  icon: any;
  title: string;
  items: string[];
}) => <div className="glass-card p-4 sm:p-6" data-id="element-321">
    <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-5 pb-3 sm:pb-4 border-b border-slate-200" data-id="element-322">
      <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-slate-100 flex items-center justify-center" data-id="element-323">
        <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-gold-600" data-id="element-324" />
      </div>
      <h3 className="text-base sm:text-xl font-bold text-slate-900" data-id="element-325">{title}</h3>
    </div>
    <ul className="space-y-2 sm:space-y-3" data-id="element-326">
      {items.map((item, i) => <li key={i} className="flex items-start gap-2 sm:gap-3" data-id="element-327">
          <CheckCircle2Icon className="w-4 h-4 sm:w-5 sm:h-5 text-green-500 shrink-0 mt-0.5" data-id="element-328" />
          <span className="text-xs sm:text-base text-slate-600" data-id="element-329">{item}</span>
        </li>)}
    </ul>
  </div>;
export function TechnicalFixes() {
  return <SlideLayout data-id="element-330">
      <div className="mb-6 sm:mb-10" data-id="element-331">
        <div className="w-12 h-1 bg-gold-500 mb-4 sm:mb-6 rounded-full" data-id="element-332" />
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-333">
          Technical SEO Fixes
        </h2>
        <p className="text-sm sm:text-xl text-slate-500" data-id="element-334">
          Resolving these technical issues improves crawlability, rankings, and
          user experience.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6 mb-4 sm:mb-8" data-id="element-335">
        <FixGroup icon={BugIcon} title="Crawl & Index" items={['Fix external 4XX errors', 'Fix internal 4XX errors', 'Set up proper redirects', 'Improve page speed']} data-id="element-336" />
        <FixGroup icon={TypeIcon} title="Meta & Titles" items={['Fix duplicate meta titles', 'Shorten long meta titles', 'Add missing meta descriptions', 'Shorten long meta descriptions']} data-id="element-337" />
        <FixGroup icon={Heading1Icon} title="Content Structure" items={['Add missing H1 tags', 'Fix multiple H1 issues', 'Add missing H2 tags', 'Improve heading hierarchy']} data-id="element-338" />
        <FixGroup icon={ImageIcon} title="Media & Schema" items={['Compress images over 100KB', 'Add missing alt text', 'Implement schema markup', 'Optimize Core Web Vitals']} data-id="element-339" />
      </div>

      <div className="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 rounded-xl bg-blue-50 border border-blue-200" data-id="element-340">
        <InfoIcon className="w-5 h-5 sm:w-6 sm:h-6 text-blue-500 shrink-0 mt-0.5" data-id="element-341" />
        <p className="text-xs sm:text-sm text-blue-900 leading-relaxed" data-id="element-342">
          <strong className="font-semibold text-slate-900" data-id="element-343">
            Technical SEO forms the foundation.
          </strong>{' '}
          These fixes ensure search engines can properly crawl, index, and rank
          your content, maximizing the ROI of all other marketing efforts.
        </p>
      </div>
    </SlideLayout>;
}